module.exports = __webpack_public_path__ + "img/empty.0e325bf8.png";